import { PersonellIdCard } from '../personnel/personnel.model';

export const dataProtectionOfficerIdCard: PersonellIdCard = {
    prefix: 'Frau',
    name: 'Janina Rochon',
    gender: 'female',
    infos: [
        'Bundesinstitut für Risikobewertung (BfR)',
        'Postfach: 12 69 42',
        'Tel.: 030 18412 31002'
    ],
    email: 'dsb@bfr.bund.de'
};

export const dataProtectionLinks = {
    dsGvoLink: 'https://eur-lex.europa.eu/legal-content/DE/TXT/HTML/?uri=CELEX:32016R0679'
};
